import storage from '@shared/js/storage';
import { EVENT } from '..';

const handleProgress = (value) => {
	// only store position if it's greater than 1 to avoid race condition between stored position and player position
	if (storage.playerRestore && value > 1) {
		storage.playerRestore = {
			...storage.playerRestore,
			position: value,
		};
	}
};

const register = (bus) => {
	bus.subscribe(EVENT.PLAYER.ON.PROGRESS, handleProgress);
};

export default register;
